export default (topRaces) => ({
  type: "SEND_TOP_RACES",
  payload: { topRaces }
});
